import React from 'react'
import PropTypes from 'prop-types'
import WishlistToggle from '../../wishlist-toggle'

/**
 * Add/Remove wishlist product tile overlay button
 *
 * @param isDisabled
 * @param {object} product
 * @param {function} onClick
 */
const WishlistOverlayButton = ({isDisabled, product, onClick}) => {
    return (
        <WishlistToggle
            isDisabled={isDisabled}
            product={product}
            variant="productTile"
            onClick={onClick}
        />
    )
}

WishlistOverlayButton.propTypes = {
    isDisabled: PropTypes.bool,
    product: PropTypes.object,
    onClick: PropTypes.func
}

export default WishlistOverlayButton
